import { render, staticRenderFns } from "./FloatingCsat.vue?vue&type=template&id=637c6b1e&scoped=true&"
import script from "./FloatingCsat.vue?vue&type=script&lang=js&"
export * from "./FloatingCsat.vue?vue&type=script&lang=js&"
import style0 from "./FloatingCsat.vue?vue&type=style&index=0&id=637c6b1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637c6b1e",
  null
  
)

export default component.exports